<template>
  <div class="category" v-if="categoriesName.length>0"  style="margin-bottom:8px">
    <ul class="main_category_list" v-bind:style="{ marginLeft : paddingLeftValue + 'px' }" style="justify-content: flex-start">
      <li class="heading" v-if="$route.name === 'home'">{{$t('category')}}</li>
      <li
        class="active"
        v-for="(category,index) in categoriesName"
        :key="index"
      >
      <p v-if="category.langData && category.langData.hasOwnProperty(cookie)" @click="goToGetProductByCategory(category.id,category.langData[cookie],index)">{{category.langData[cookie]}}</p>
            <p @click="goToGetProductByCategory(category.id,category.name,index)" v-else>{{category.name}}</p>
      <!-- {{category.name}} -->
      </li>
    </ul>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import { mapState } from "vuex";
import constant from "../../utils/constant";
import ImageSpinner from "../Common/ImageSpinner";
const cookie = VueCookie.get('lang')
export default {
  name: "Category",
  components: {
    ImageSpinner
  },
  props: {
    categoriesName: {
      type: Array
    }
  },
  data() {
    return {
      width: "",
      paddingLeftValue: "",
      selectedCatId: 0 ,
      cookie:''
    };
  },
  methods: {
    goToGetProductByCategory(categoryId, name) {
      if(this.$route.name === 'home'){
        if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier){
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier);
        }else if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier){
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier);
        }else if(this.$route.query.shopid){
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid);
        }else{
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + categoryId)
        }
       this.$store.commit("saveCategoryFilterData", {
        catfilterProdList: {}
      });
      this.$store.commit("saveCategoriesData", {
        categoriesProdList: [],
        categoriesPageIndex: 0
      });
      }else{
        if(this.selectedCatId == categoryId){
          return
        }else{
          this.selectedCatId = categoryId;
        this.$emit('filterFeedProd', categoryId)
        }
        
      }
      
    },
    goToCategoryListing(categoryId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/category-listing");
    }
  },
  updated() {
    this.$nextTick(function() {});
    if (this.categoriesName.length > 0) {
      let element = document.getElementsByClassName("heading");
      this.paddingLeftValue = element[0].offsetWidth * 1.15;
    }
  },
  mounted() {
    this.cookie = cookie
    if (this.categoriesName.length > 0) {
      let element = document.getElementsByClassName("heading");
      this.paddingLeftValue = element[0].offsetWidth * 1.15;
    }
    if(this.$store.getters.personalCategoryIndex){
      this.selectedCatId = this.$store.getters.personalCategoryIndex
    }
  }
};
</script>
<style scoped>
.main_category_list li.heading.allCatHead{
  font-size: 0.938em;
    background: none;
    padding-top: 0;
}
.main_category_list li.active span{
      padding-bottom: 6px;
    border-bottom: 2px solid #138808;
    color: #138808;
}
</style>